<template>
  <div class="phone">
    <div class="title">
      <p class="on">登录</p>
      <p @click="setMode">注册</p>
    </div>
    <div class="con">
      <div class="top">
        <el-form>
          <el-input
            placeholder="请输入账号"
            v-model="username"
            class="input-with-select"
          >
            <template slot="prepend">账号：</template>
          </el-input>
          <el-input placeholder="请输入密码" v-model="password" show-password>
            <template slot="append"><i class="el-icon-lock"></i></template>
          </el-input>
        </el-form>
      </div>
      <button class="btn" @click="passLogin">登录</button>
      <div class="text">
        <Agreement></Agreement>
      </div>
    </div>
  </div>
</template>

<script>
import Agreement from '@/components/login/agreement/agreement.vue'
import service from './phone'

export default {
  name: 'phone',
  data () {
    return {
      isHideFun: 'true',
      select: '1',
      username: '',
      password: ''
    }
  },
  components: {
    Agreement
  },
  created () {
  },
  computed: {
    isPassLogin () {
      return this.$store.state.login.isPassWordLogin
    },
    system () {
      return this.$store.state.getsystem.system
    }
  },
  methods: {
    BatchesFun (e) {
      this.isHideFun = e
    },
    // 改变登录模式
    setLoginMode () {
      this.$store.dispatch('set_isPassLogin', false)
    },
    setMode () {
      this.$store.dispatch('set_isLogin', false)
    },
    resetMode () {
      this.$store.dispatch('set_isReset', false)
    },
    passLogin () {
      service.login(this)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./phone.scss";
</style>



// WEBPACK FOOTER //
// src/components/login/phone/phone.vue